import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import BannerData from '~/static/banner/data/UnitSaleBanner.json';
import Nl2br from 'vue-nl2br';
var UnitImage = function UnitImage() {
  return import('@/components/atoms/UnitImage');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var ShopUnitStatusViewer = function ShopUnitStatusViewer() {
  return import('@/components/molecules/ShopUnitStatusViewer');
};
var FilterCheckbox = function FilterCheckbox() {
  return import('@/components/atoms/FilterCheckbox');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
var MintUnitViewer = function MintUnitViewer() {
  return import('@/components/organisms/MintUnitViewer');
};
var BikkuriInfoBox = function BikkuriInfoBox() {
  return import('@/components/molecules/BikkuriInfoBox');
};
export default {
  components: {
    FilterCheckbox: FilterCheckbox,
    Nl2br: Nl2br,
    RarityIcon: RarityIcon,
    Modal: Modal,
    UnitImage: UnitImage,
    ShopUnitStatusViewer: ShopUnitStatusViewer,
    PrimeIcon: PrimeIcon,
    MintUnitViewer: MintUnitViewer,
    BikkuriInfoBox: BikkuriInfoBox
  },
  data: function data() {
    return {
      exchangeType: 0,
      extensions: [],
      loading: false,
      banner: BannerData,
      raritiesUnselect: [null, true, true, true, true, true],
      // start from 1 for readability
      isExtensionExchangeModalShown: false,
      isConsumableItemExchangeModalShown: false,
      isOfferSaleExchangeModalShown: false,
      isMintUnitViewerShown: false,
      rewardSelected: null,
      resultAsset: {},
      chart: null,
      chartInit: {
        data: {
          labels: [],
          datasets: [{
            label: 'Price',
            lineTension: 0,
            borderColor: '#f1c40f',
            backgroundColor: 'rgba(241, 196, 15, 0.2)',
            pointRadius: 0,
            data: []
          }, {
            label: 'Prediction',
            lineTension: 0,
            borderColor: '#ccc',
            borderWidth: 1,
            borderDash: [1, 2],
            fill: false,
            pointRadius: 0,
            data: []
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontColor: '#999'
              },
              gridLines: {
                color: '#666',
                zeroLineColor: '#666'
              }
            }],
            xAxes: [{
              type: 'time',
              distribution: 'linear',
              time: {
                unit: 'day',
                min: null,
                max: null
              },
              gridLines: {
                display: false
              },
              ticks: {
                fontColor: '#999'
              }
            }]
          }
        }
      },
      isChartShown: false,
      consumableItems: [{
        type: 202,
        price: 10,
        id: 1101,
        canExchangeCount: 100
      },
      // 0は無限
      {
        type: 202,
        price: 10,
        id: 1001,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 60,
        id: 1002,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 40,
        id: 1003,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 40,
        id: 1004,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 20,
        id: 1005,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 20,
        id: 1006,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 60,
        id: 1007,
        canExchangeCount: 100
      }, {
        type: 202,
        price: 10,
        id: 1102,
        canExchangeCount: 100
      }, {
        type: 201,
        price: 15,
        id: 10002,
        canExchangeCount: 100
      }, {
        type: 203,
        price: 100,
        id: 10006,
        canExchangeCount: 100
      }, {
        type: 203,
        price: 60,
        id: 10005,
        canExchangeCount: 100
      }, {
        type: 203,
        price: 30,
        id: 10004,
        canExchangeCount: 100
      }],
      offerSaleItems: [],
      consumableItemSelectCount: 0,
      extensionFilterModalShown: false,
      waitSeconds: 0,
      lockedTimerId: 0,
      saleLockUntil: 0,
      scrollPosition: 0,
      hideSoldOutTmp: false,
      extensionFilterModeTmp: 6,
      heroExpItems: [],
      extensionExpItems: [],
      limitedTimeItems: [],
      selectedFilters: {
        hideSoldOut: false,
        extensionFilterMode: 6,
        raritiesUnselect: [null, true, true, true, true, true] // start from 1 for readability
      },
      loadLimit: 0,
      isConfirmationModalShown: false
    };
  },
  computed: {
    getExtensionType: function getExtensionType() {
      return useExtensionMaster().getExtensionType;
    },
    bfhPointBalance: function bfhPointBalance() {
      return useConsumableStore().getMyBalance.bfhPoint;
    },
    reliecBalance: function reliecBalance() {
      return useConsumableStore().getMyBalance.reliec;
    },
    getConsumeItem: function getConsumeItem() {
      return useConsumableMaster().getConsumeItem;
    },
    getReward: function getReward() {
      return useRewardStore().getReward;
    },
    sales: function sales() {
      return useExtensionStore().getSales;
    },
    getSkill: function getSkill() {
      var item = this.rewardSelected.asset || this.getReward(this.rewardSelected.saleItem);
      if (!item.active) return {
        description: {
          ja: {
            effects: []
          },
          en: {
            effects: []
          }
        }
      };
      return useSkillMaster().getSkillById(item.active);
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    bannerUrl: function bannerUrl() {
      return this.banner.url[this.$i18n.locale];
    },
    bannerImage: function bannerImage() {
      return this.$env.cdnUrl + '/rsc' + this.banner.image[this.$i18n.locale];
    },
    formattedRewards: function formattedRewards() {
      var _this = this;
      if (this.loading) {
        return [];
      }
      var formattedRewards = this.sales.map(function (reward) {
        return {
          asset: _this.getExtensionType(reward.extensionType),
          exchangeLimit: reward.supplyLimit,
          viewSince: reward.viewSince * 1000,
          // Adjust unix time for js moment
          saleSince: reward.saleSince * 1000,
          // Adjust unix time for js moment
          ticketType: 3,
          // On this page all use winners tickets,
          remainingStock: reward.supplyLimit - reward.resultsList.length,
          price: reward.currentPrice.price,
          index: reward.index
        };
      });

      // Apply filter if rarity is selected
      if (!this.raritiesUnselect.filter(function (b) {
        return b == false;
      }).length == 0) {
        formattedRewards = formattedRewards.filter(function (reward) {
          return !_this.raritiesUnselect[_this.getExtensionType(reward.asset.extensionType).rarity];
        });
      }

      // Apply filter if sold out
      if (this.selectedFilters.hideSoldOut) {
        formattedRewards = formattedRewards.filter(function (reward) {
          return reward.remainingStock > 0;
        });
      }
      if (this.selectedFilters.extensionFilterMode == 1) {
        return formattedRewards.sort(function (a, b) {
          return a.index - b.index;
        }).slice(0, this.loadLimit);
      } else if (this.selectedFilters.extensionFilterMode == 2) {
        return formattedRewards.sort(function (rewardA, rewardB) {
          if (rewardA.price < rewardB.price) return -1;
          if (rewardA.price === rewardB.price) return 0;
          if (rewardA.price > rewardB.price) return 1;
        }).slice(0, this.loadLimit);
      } else if (this.selectedFilters.extensionFilterMode == 3) {
        return formattedRewards.sort(function (rewardA, rewardB) {
          if (rewardA.price < rewardB.price) return 1;
          if (rewardA.price === rewardB.price) return 0;
          if (rewardA.price > rewardB.price) return -1;
        }).slice(0, this.loadLimit);
      } else if (this.selectedFilters.extensionFilterMode == 4) {
        return formattedRewards.sort(function (rewardA, rewardB) {
          if (rewardA.remainingStock < rewardB.remainingStock) return -1;
          if (rewardA.remainingStock === rewardB.remainingStock) return 0;
          if (rewardA.remainingStock > rewardB.remainingStock) return 1;
        }).slice(0, this.loadLimit);
      } else if (this.selectedFilters.extensionFilterMode == 5) {
        return formattedRewards.sort(function (rewardA, rewardB) {
          if (rewardA.remainingStock < rewardB.remainingStock) return 1;
          if (rewardA.remainingStock === rewardB.remainingStock) return 0;
          if (rewardA.remainingStock > rewardB.remainingStock) return -1;
        }).slice(0, this.loadLimit);
      } else {
        return formattedRewards.sort(function (rewardA, rewardB) {
          var rarityA = Math.floor(rewardA.asset.extensionType / 1000);
          var rarityB = Math.floor(rewardB.asset.extensionType / 1000);
          var seriesA = rewardA.asset.extensionType % 1000;
          var seriesB = rewardB.asset.extensionType % 1000;

          // シーリズからのレアリティー順
          if (seriesA < seriesB) return -1;
          if (seriesA > seriesB) return 1;
          if (seriesA == seriesB) {
            if (rarityA < rarityB) return -1;
            if (rarityA > rarityB) return 1;
          }
        }).slice(0, this.loadLimit);
      }
    },
    waitString: function waitString() {
      var waitTime;
      var waitUnitString;
      var hour = 60 * 60;
      var day = hour * 24;
      if (this.waitSeconds < 60) {
        waitTime = this.waitSeconds;
        if (this.$i18n.locale === 'ja') waitUnitString = '秒';else waitUnitString = 'Second';
      } else if (this.waitSeconds < hour) {
        waitTime = this.waitSeconds / 60;
        if (this.$i18n.locale === 'ja') waitUnitString = '分';else waitUnitString = 'Minute';
      } else if (this.waitSeconds < day) {
        waitTime = this.waitSeconds / 60 / 60;
        if (this.$i18n.locale === 'ja') waitUnitString = '時間';else waitUnitString = 'Hour';
      } else {
        waitTime = this.waitSeconds / 60 / 60 / 24;
        if (this.$i18n.locale === 'ja') waitUnitString = '日';else waitUnitString = 'Day';
      }
      waitTime = Math.round(waitTime);
      if (this.$i18n.locale === 'ja') return "(\u8CFC\u5165\u53EF\u80FD\u307E\u3067\u3042\u3068".concat(waitTime).concat(waitUnitString, ")");
      return "(Wait ".concat(waitTime, " ").concat(waitUnitString, " to buy)");
    },
    NotCommonOrUncommon: function NotCommonOrUncommon() {
      return this.rewardSelected.asset.rarity != 1 && this.rewardSelected.asset.rarity != 2;
    },
    isExtension: function isExtension() {
      return this.exchangeType == 0;
    },
    confirmationPaymentItemName: function confirmationPaymentItemName() {
      return this.exchangeType == 2 ? this.getConsumeItem(this.rewardSelected.paymentItemId).name[this.$i18n.locale] : this.getConsumeItem(this.$constants.EXCHANGE_CONSUMEIDS.BfhPoint).name[this.$i18n.locale];
    },
    confirmationPurchaseItemName: function confirmationPurchaseItemName() {
      if (this.exchangeType == 0) {
        return this.rewardSelected.asset.name[this.$i18n.locale];
      } else if (this.exchangeType == 1) {
        return this.getReward(this.rewardSelected).name[this.$i18n.locale] + ' x' + this.consumableItemSelectCount;
      } else if (this.exchangeType == 2) {
        return this.getReward(this.rewardSelected.saleItem).name[this.$i18n.locale];
      }
    },
    confirmationPurchaseItemPrice: function confirmationPurchaseItemPrice() {
      if (this.exchangeType == 0) {
        return this.rewardSelected.price;
      } else if (this.exchangeType == 1) {
        return this.rewardSelected.price * this.consumableItemSelectCount;
      } else if (this.exchangeType == 2) {
        return this.rewardSelected.price;
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (window.localStorage.getItem('mch:extensionMarketFilter') != null && window.localStorage.getItem('mch:extensionMarketFilter') != 'undefined') {
              _this2.selectedFilters = JSON.parse(window.localStorage.getItem('mch:extensionMarketFilter'));
              _this2.extensionFilterModeTmp = _this2.selectedFilters.extensionFilterMode;
              _this2.hideSoldOutTmp = _this2.selectedFilters.hideSoldOut;
              _this2.raritiesUnselect = _this2.selectedFilters.raritiesUnselect;
            } else {
              window.localStorage.setItem('mch:extensionMarketFilter', JSON.stringify(_this2.$util.clone(_this2.selectedFilters)));
            }
            _this2.loading = true;
            _this2.exchangeType = parseInt(_this2.$route.query.exchangeType) || 0;
            _this2.fetchCurrentConsumeMyItems();
            _context.next = 6;
            return _this2.fetchOfferSaleInfo();
          case 6:
            _this2.loadLimit = 16;
            _this2.loading = false;
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            document.getElementById('__layout').addEventListener('scroll', _this3.updateScroll);
            window.addEventListener('scroll', _this3.updateScroll);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    updateScroll: function updateScroll() {
      this.scrollPosition = window.scrollY || document.getElementById('__layout').scrollTop;
      if (this.loadLimit < this.sales.length) {
        this.loadLimit += 8;
      }
    },
    makeCanExchangeCountArray: function makeCanExchangeCountArray(reward) {
      var countArray = [];
      for (var i = 1; i <= reward.canExchangeCount; i++) {
        countArray.push(i);
      }
      return countArray;
    },
    openConfirmationModal: function openConfirmationModal() {
      this.isConfirmationModalShown = true;
    },
    buyExtension: function buyExtension() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this4.$salesService.buyExtension(_this4.rewardSelected.asset.extensionType, _this4.rewardSelected.price);
            case 3:
              _this4.closeExtensionExchangeModal();
              _this4.fetchCurrentConsumeMyItems();
              _context3.next = 7;
              return useExtensionStore().fetchExtensionSales();
            case 7:
              _this4.$toast.success('Success.');
              _context3.next = 18;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
              _this4.closeExtensionExchangeModal();
              _this4.fetchCurrentConsumeMyItems();
              _context3.next = 17;
              return useExtensionStore().fetchExtensionSales();
            case 17:
              if (_context3.t0.message === "sale hasn't started yet") {
                _this4.$toast.error(_this4.$i18n.locale === 'ja' ? '販売時間外です' : "sale hasn't started yet");
              } else if (_context3.t0.message === 'error asking price exceeded') {
                _this4.$toast.error(_this4.$i18n.locale === 'ja' ? '販売価格が更新されました、再度お試し下さい' : 'error asking price exceeded');
              } else if (_context3.t0.message === 'balance shortage') {
                _this4.$toast.error(_this4.$i18n.locale === 'ja' ? 'ブレヒロポイントが足りないです' : 'balance shortage');
              } else {
                _this4.$toast.error('Error');
              }
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 10]]);
      }))();
    },
    buyConsumableItem: function buyConsumableItem() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (!(_this5.consumableItemSelectCount > _this5.rewardSelected.canExchangeCount && _this5.rewardSelected.canExchangeCount != 0)) {
                _context4.next = 3;
                break;
              }
              throw 'exceeded';
            case 3:
              _context4.next = 5;
              return _this5.$salesService.buyConsumableItem(_this5.rewardSelected.id, _this5.rewardSelected.type, _this5.consumableItemSelectCount,
              //- ゼル交換場2/10/2023もう使わない
              // this.exchangeType == 2 ? true : false
              false);
            case 5:
              _this5.isConsumableItemExchangeModalShown = false;
              _this5.fetchCurrentConsumeMyItems();
              _this5.$toast.success('Success.');
              _context4.next = 15;
              break;
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              _this5.isConsumableItemExchangeModalShown = false;
              _this5.fetchCurrentConsumeMyItems();
              if (_context4.t0.message === 'balance shortage') {
                if (_this5.exchangeType == 1) {
                  _this5.$toast.error(_this5.$i18n.locale === 'ja' ? 'ブレヒロポイントが足りないです' : 'balance shortage');
                } else {
                  _this5.$toast.error(_this5.$i18n.locale === 'ja' ? 'ゼルが足りないです' : 'balance shortage');
                }
              } else if (_context4.t0 === 'exceeded') {
                _this5.$toast.error(_this5.$i18n.locale === 'ja' ? '制限個数より多いです' : 'Amount exceeded the limitation');
              } else {
                _this5.$toast.error('Error');
              }
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 10]]);
      }))();
    },
    buyOfferSale: function buyOfferSale() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return _this6.$salesService.purchaseOfferSale(_this6.rewardSelected.offerSaleType, _this6.rewardSelected.price);
            case 3:
              res = _context5.sent;
              if (!(_this6.rewardSelected.saleItem.itemType == 902)) {
                _context5.next = 9;
                break;
              }
              _context5.next = 7;
              return useHeroStore().fetchHero(res.mintedId);
            case 7:
              _this6.resultAsset = useHeroStore().getHero(res.mintedId);
              _this6.isMintUnitViewerShown = true;
            case 9:
              _this6.$toast.success('Success.');
              _context5.next = 16;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](0);
              console.log(_context5.t0);
              _this6.$toast.error('Error');
            case 16:
              _this6.isOfferSaleExchangeModalShown = false;
              _this6.fetchCurrentConsumeMyItems();
              _context5.next = 20;
              return _this6.fetchOfferSaleInfo();
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 12]]);
      }))();
    },
    confirmPurchase: function confirmPurchase() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(_this7.exchangeType == 0)) {
                _context6.next = 5;
                break;
              }
              _context6.next = 3;
              return _this7.buyExtension();
            case 3:
              _context6.next = 13;
              break;
            case 5:
              if (!(_this7.exchangeType == 1)) {
                _context6.next = 10;
                break;
              }
              _context6.next = 8;
              return _this7.buyConsumableItem();
            case 8:
              _context6.next = 13;
              break;
            case 10:
              if (!(_this7.exchangeType == 2)) {
                _context6.next = 13;
                break;
              }
              _context6.next = 13;
              return _this7.buyOfferSale();
            case 13:
              _this7.isConfirmationModalShown = false;
            case 14:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    closeExtensionExchangeModal: function closeExtensionExchangeModal() {
      this.isExtensionExchangeModalShown = false;
      if (this.lockedTimerId) {
        clearInterval(this.lockedTimerId);
      }
    },
    filterExtension: function filterExtension() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this8.selectedFilters.hideSoldOut = _this8.hideSoldOutTmp;
              _this8.selectedFilters.extensionFilterMode = _this8.extensionFilterModeTmp;
              window.localStorage.setItem('mch:extensionMarketFilter', JSON.stringify(_this8.$util.clone(_this8.selectedFilters)));
              _this8.extensionFilterModalShown = false;
              useExtensionStore().fetchExtensionSales();
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    changeExchangeType: function changeExchangeType(tp) {
      this.exchangeType = tp;
      this.$router.push({
        query: {
          exchangeType: tp
        }
      });
    },
    toggleRaritySelected: function toggleRaritySelected(rarity) {
      this.raritiesUnselect[rarity] = !this.raritiesUnselect[rarity];
      this.selectedFilters.raritiesUnselect = this.raritiesUnselect;
      window.localStorage.setItem('mch:extensionMarketFilter', JSON.stringify(this.$util.clone(this.selectedFilters)));
      this.loading = true;
      this.$forceUpdate();
      this.loading = false;
    },
    checkLocked: function checkLocked() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var now, waitSeconds;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              now = +_this9.$dayjs().format('x');
              waitSeconds = _this9.saleLockUntil ? Math.floor((_this9.saleLockUntil - now) / 1000) : 0;
              _this9.waitSeconds = waitSeconds < 0 ? 0 : waitSeconds;
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    openExtensionModal: function openExtensionModal(reward) {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this10.rewardSelected = reward;
              _this10.isChartShown = false;
              _context9.next = 4;
              return _this10.$salesService.getSaleLockedUntil();
            case 4:
              _context9.t0 = _context9.sent;
              _this10.saleLockUntil = _context9.t0 * 1000;
              _context9.next = 8;
              return _this10.checkLocked();
            case 8:
              if (_this10.rewardSelected.remainingStock) {
                if (_this10.lockedTimerId) {
                  clearInterval(_this10.lockedTimerId);
                }
                _this10.lockedTimerId = setInterval(_this10.checkLocked.bind(_this10), 1000);
              }
              _this10.isExtensionExchangeModalShown = true;
              _this10.setChart();
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    openConsumableItemModal: function openConsumableItemModal(reward) {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.consumableItemSelectCount = 0;
              _this11.rewardSelected = reward;
              if (!(_this11.rewardSelected.type === 202)) {
                _context10.next = 6;
                break;
              }
              if (_this11.rewardSelected.id === 2004) {
                //bfhポイント
                _this11.rewardSelected.balance = _this11.bfhPointBalance;
              } else {
                //チケット
                _this11.rewardSelected.balance = useConsumableStore().getConsumeMyItems.filter(function (x) {
                  return x.consumeItemId == _this11.rewardSelected.id;
                })[0].balance;
              }
              _context10.next = 22;
              break;
            case 6:
              if (!(_this11.rewardSelected.type === 200)) {
                _context10.next = 12;
                break;
              }
              _context10.next = 9;
              return _this11.fetchHeroExpItems();
            case 9:
              _this11.rewardSelected.balance = _this11.heroExpItems.filter(function (x) {
                return x.heroItemId == _this11.rewardSelected.id;
              })[0].balance;
              _context10.next = 22;
              break;
            case 12:
              if (!(_this11.rewardSelected.type === 203)) {
                _context10.next = 18;
                break;
              }
              _context10.next = 15;
              return _this11.fetchExtensionExpItems();
            case 15:
              _this11.rewardSelected.balance = _this11.extensionExpItems.filter(function (x) {
                return x.extensionItemId == _this11.rewardSelected.id;
              })[0].balance;
              _context10.next = 22;
              break;
            case 18:
              if (!(_this11.rewardSelected.type === 201)) {
                _context10.next = 22;
                break;
              }
              _context10.next = 21;
              return _this11.fetchCurrentLimitedMyItems();
            case 21:
              _this11.rewardSelected.balance = _this11.limitedTimeItems.length;
            case 22:
              _this11.isConsumableItemExchangeModalShown = true;
            case 23:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    openOfferSaleModal: function openOfferSaleModal(reward) {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this12.rewardSelected = reward;
              _this12.isOfferSaleExchangeModalShown = true;
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    fetchExtensionExpItems: function fetchExtensionExpItems() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var extensionItems;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this13.$extensionsService.getExtensionExpItems();
            case 2:
              extensionItems = _context12.sent;
              _this13.extensionExpItems.length = 0;
              _this13.extensionExpItems = extensionItems.extensionItemsList;
            case 5:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    fetchHeroExpItems: function fetchHeroExpItems() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var items;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this14.$heroesService.getHeroExpItems();
            case 2:
              items = _context13.sent;
              _this14.heroExpItems.length = 0;
              _this14.heroExpItems = items.heroItemsList;
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    fetchCurrentLimitedMyItems: function fetchCurrentLimitedMyItems() {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return useConsumableStore().fetchLimitedMyItems();
            case 2:
              _this15.limitedTimeItems = 0;
              _this15.limitedTimeItems = useConsumableStore().getLimitedMyItems;
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    fetchCurrentConsumeMyItems: function fetchCurrentConsumeMyItems() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return useConsumableStore().fetchConsumeMyItems();
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }))();
    },
    fetchOfferSaleInfo: function fetchOfferSaleInfo() {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var offerSaleItems;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return _this16.$salesService.getOfferSaleResults();
            case 2:
              _this16.offerSaleResults = _context16.sent;
              _context16.next = 5;
              return _this16.$salesService.getCurrentOfferSaleTypes();
            case 5:
              offerSaleItems = _context16.sent;
              offerSaleItems.forEach(function (item) {
                var sameGroupOfferTypeIds = offerSaleItems.filter(function (e) {
                  return e.groupId === item.groupId;
                }).map(function (e) {
                  return e.offerSaleType;
                });
                var len = _this16.offerSaleResults.filter(function (e) {
                  return sameGroupOfferTypeIds.includes(e.offerSaleType);
                }).length;
                item.price = item.priceListList[Math.min(len, item.priceListList.length - 1)];
              });
              _this16.offerSaleItems = offerSaleItems;
            case 8:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    isInViewTerm: function isInViewTerm(sale) {
      if (this.exchangeType == 2) {
        var _since = this.$dayjs(sale.viewPeriod.since * 1000);
        var until = this.$dayjs(sale.viewPeriod.until * 1000);
        return this.$dayjs().isBetween(_since, until);
      }
      var since = this.$dayjs(sale.viewSince);
      return this.$dayjs().isAfter(since);
    },
    isInSalesTerm: function isInSalesTerm(sale) {
      if (this.exchangeType == 2) {
        var _since2 = this.$dayjs(sale.eventPeriod.since * 1000);
        var until = this.$dayjs(sale.eventPeriod.until * 1000);
        return this.$dayjs().isBetween(_since2, until);
      }
      var since = this.$dayjs(sale.saleSince);
      return this.$dayjs().isAfter(since);
    },
    hasEnoughTickets: function hasEnoughTickets(amount) {
      if (this.exchangeType == 1 || this.exchangeType == 0) return this.bfhPointBalance >= amount;
      return this.reliecBalance >= amount;
    },
    setChart: function setChart() {
      var _this17 = this;
      var sale = this.sales.find(function (e) {
        return e.extensionType == _this17.rewardSelected.asset.extensionType;
      });
      this.chart = this.$util.clone(this.chartInit);

      // 横軸min/maxの設定
      this.chart.options.scales.xAxes[0].time.min = sale.saleSince * 1000;
      this.chart.options.scales.xAxes[0].time.max = this.$dayjs().add(1, 'd').valueOf();

      // start時点
      this.chart.data.datasets[0].data.push({
        x: sale.saleSince * 1000,
        y: sale.startPrice
      });

      // 保証価格start時点
      this.chart.data.datasets[1].data.push({
        x: sale.saleSince * 1000,
        y: sale.guaranteedPrice
      });

      // sold時点
      sale.resultsList.forEach(function (res) {
        _this17.chart.data.datasets[0].data.push({
          x: res.at * 1000,
          y: res.purchasedPrice
        });
        _this17.chart.data.datasets[0].data.push({
          x: res.at * 1000,
          y: res.increasedPrice
        });
      });

      // now時点
      this.chart.data.datasets[0].data.push({
        x: this.$dayjs().valueOf(),
        y: sale.currentPrice.price
      });

      // 保証価格now時点
      this.chart.data.datasets[1].data.push({
        x: this.$dayjs().add(1, 'd').valueOf(),
        y: sale.guaranteedPrice
      });
      this.isChartShown = true;
    },
    cannotBuyConsumableItemByCount: function cannotBuyConsumableItemByCount(reward) {
      return this.consumableItemSelectCount == 0 || reward.price * this.consumableItemSelectCount > this.bfhPointBalance;
    },
    cannotBuyOfferSale: function cannotBuyOfferSale(reward) {
      if (!this.isInSalesTerm(reward)) return true;
      if (reward.maxCountPerUser > 0 && this.offerSaleResults.filter(function (e) {
        return e.offerSaleType == reward.offerSaleType;
      }).length >= reward.maxCountPerUser) return true;
      if (reward.maxCount > 0 && reward.remainingStock <= 0) return true;
      return false;
    },
    isShowOfferSalePrice: function isShowOfferSalePrice(reward) {
      if (reward.maxCountPerUser > 0 && this.offerSaleResults.filter(function (e) {
        return e.offerSaleType == reward.offerSaleType;
      }).length >= reward.maxCountPerUser) return false;
      if (reward.maxCount > 0 && reward.remainingStock <= 0) return false;
      return true;
    },
    saleStartString: function saleStartString(sale) {
      var saleSince = sale.saleSince || sale.eventPeriod.since * 1000;
      return this.$dayjs(saleSince).format('YYYY/MM/DD HH:mm') + ' ~';
    },
    lockPeriod: function lockPeriod(rarity) {
      var duration = 0;
      switch (rarity) {
        case 1:
          duration = 0;
          break;
        case 2:
          duration = 0;
          break;
        case 3:
          duration = 12;
          break;
        case 4:
          duration = 3;
          break;
        case 5:
          duration = 7;
          break;
      }
      if (this.$i18n.locale === 'ja') {
        if (duration == 0) return 'なし';
        if (duration == 12) return '12時間';
        return duration.toString() + '日';
      } else {
        if (duration == 0) return 'None';
        if (duration == 12) return '12hour(s)';
        return duration.toString() + 'day(s)';
      }
    }
  }
};